var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest, API_PATH } from "./useRequest";
import { useState } from "@max/max";
import { useOrderPopup } from "./useOrderPopup";
import { POPUP_ORDER } from "@/const";
export function useTasksPopup(options) {
    const ctx = useMonitorEngineContext();
    const [taskPopupVisible, setTaskPopupVisible] = useOrderPopup(false, POPUP_ORDER.TASK);
    const [tasksData, setTasksData] = useState();
    const { requestStatus, request } = useRequest(API_PATH.ACTIVITY_TASK);
    function loadTasksData(params) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield request({
                    activityId: options.activityId,
                    taskIds: options.taskIds,
                    leaderId: params.leaderId
                });
                console.log('任务res', res);
                if (!Array.isArray(res === null || res === void 0 ? void 0 : res.tasks)) {
                    throw new Error('获取任务数据失败');
                }
                setTasksData(res);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.ACTIVITY_TASK
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.ACTIVITY_TASK
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
            }
        });
    }
    return {
        loadTasksData,
        tasksStatus: requestStatus,
        tasksData,
        taskPopupVisible,
        setTaskPopupVisible
    };
}
